import { useState } from 'react';
import {} from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLab } from '../lib/service';
import { Modal } from '../components/common';

/** Resolves a provider result whose billing outcome is unknown. */
export function Reconcile({ jobId, onError }: { jobId: string; onError: (e: unknown) => void }) {
  const lab = useLab();
  const [open, setOpen] = useState(false),
    [cost, setCost] = useState(''),
    [note, setNote] = useState('');
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        Reconcile
      </Button>
      {open && (
        <Modal
          title="Reconcile provider outcome"
          subtitle="Check Google’s operation and billing records before closing this reservation."
          onClose={() => setOpen(false)}
        >
          <label className="field-label">
            Verified charge (USD)
            <input
              type="number"
              min="0"
              step="0.000001"
              value={cost}
              onChange={(e) => setCost(e.target.value)}
            />
          </label>
          <label className="field-label">
            Audit note
            <textarea value={note} onChange={(e) => setNote(e.target.value)} />
          </label>
          <Button
            disabled={cost === '' || note.trim().length < 10}
            onClick={() =>
              void lab
                .reconcile({ jobId, costMicros: Math.round(Number(cost) * 1e6), note })
                .then(() => setOpen(false))
                .catch(onError)
            }
          >
            Record verified outcome
          </Button>
        </Modal>
      )}
    </>
  );
}
